import { toNumber } from 'lodash'
import { isValidAmount } from 'utils'

const currencyRegex = /[0-9-.]/g

const formatAndValidatePercentage = (
  input,
  inputField,
  record,
  ignoreFormatErrorMessage = false
) => {
  if (ignoreFormatErrorMessage) input = input.replace(/[^$\d,.]/g, '')
  const sanitizedInput = input.match(currencyRegex)?.join('')
  let value = toNumber(sanitizedInput)
  let formattedNumber = value.toFixed(2)
  if (isNaN(value) || !isValidAmount(input)) {
    record.addError(inputField, 'Format must be: XX.XX%')
    record.set(inputField, input)
  } else if (formattedNumber < 0) {
    record.addError(inputField, 'Percentage cannot be negative')
    record.set(inputField, `${formattedNumber}%`)
  } else if (formattedNumber > 100) {
    record.addError(inputField, 'Percentage must be between 0 and 100')
    record.set(inputField, `${formattedNumber}%`)
  } else {
    record.set(inputField, `${formattedNumber}%`)
  }
  return
}

export default formatAndValidatePercentage
